import type { JsonSchema, NestedObject, UISchemaElement } from '@restore/reform';
import { baseApiUrl } from 'src/config';
import { getAccessToken } from 'src/routes/AuthContext';
import { IcdCode } from './types';

export type Icd10Response = {
  icd10TMedicalCodes: IcdCode[];
  icd10TreatmentCodes: IcdCode[];
  error: false | string;
};

export const getIcdCodes = async (
  realm: string,
  formSubmissionUuid: string
): Promise<Icd10Response> => {
  const token = await getAccessToken();

  return fetch(
    `${baseApiUrl}/document/form/edit-icd-codes?formSubmissionId=${formSubmissionUuid}`,
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'x-tenant-id': realm,
      },
    }
  )
    .then((response) => {
      return response.json();
    })
    .then((responseObj) => {
      // THIN-7294: the GET wire field is icd10MedicalCodes (THIN-7269 dropped the
      // Jotform-era "T"); the FE schema/form key is still icd10TMedicalCodes. Map it
      // here so ReForm initialData pre-fills. Mirrors the write-side adapter in
      // submitIcdCodes.ts. Treatment codes share the same name on both sides.
      return {
        icd10TreatmentCodes: responseObj.data?.icd10TreatmentCodes ?? [],
        icd10TMedicalCodes: responseObj.data?.icd10MedicalCodes ?? [],
        error: responseObj.code === 'OK' ? false : responseObj.message,
      };
    })
    .catch((error) => {
      throw Error(`Error fetching ICD10 codes: ${error}`);
    });
};
